module.exports = angular.module('msi.utils.cookies', ['ngCookies']).name;

angular.module(module.exports)
  .factory('cookiesService', require('./cookies.service'));
